import React, { Component } from 'react';
import WebQuestionView from './WebQuestionView';

export default class WebQuestionPanel extends React.Component{
	constructor(props) {
	 super(props);
	 this.markedquesFn = this.markedquesFn.bind(this);

	 this.state = {
		isStarView: false,
	  }
	 }

	 markedquesFn(event){
		//event.currentTarget.classList.toggle("selected")
		this.setState({ isStarView: !this.state.isStarView })
	}

	 render() {		 
	   return(
        <div className="qcont">
{/* marked questions hidden -- kamaraj */}
		{/*<div className="qstar"><span className="starIcon" onClick={this.markedquesFn}>
        { this.state.isStarView
          ? <i className="material-icons strclr">star</i>
          : <i className="material-icons strbclr">star_border</i>
        }</span></div>*/}
             <WebQuestionView qno={this.props.qno} qdata={this.props.qdata} ga={this.props.ga} callbackParent={this.markedquesFn} existingRatingObj={this.props.existingRatingObj} accessId={this.props.accessId} classId={this.props.classId} recomLocked={this.props.recomLocked}/>
        </div>
	   );
	  }
} 


// WEBPACK FOOTER //
// ./src/components/question/WebQuestionPanel.js